// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pill[data-v-63ce3e3d]{border-radius:5rem;font-size:.625rem}", "",{"version":3,"sources":["webpack://./src/resources/js/common/Components/UserRole/UI/UserMedia.vue"],"names":[],"mappings":"AACA,uBACI,kBAAA,CACA,iBAAJ","sourcesContent":["\n.pill\n    border-radius: 5rem\n    font-size: .625rem\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
